import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enregistrer le Service Worker pour PWA
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('[PWA] Service Worker enregistré avec succès');
  },
  onUpdate: (registration) => {
    console.log('[PWA] Nouvelle version disponible');
    // Optionnel : afficher une notification à l'utilisateur
    if (window.confirm('Nouvelle version disponible ! Actualiser maintenant ?')) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
